import { ModuleWithProviders, NgModule, Optional, SkipSelf, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SessionInformationService } from './session-information.service';
import { AppInformationService } from './app-information.service';
import { GenesisUnitOfWork } from 'app/core/data/genesis-unit-of-work';
import { EntityManagerProvider } from 'app/core/data/entity-manager-provider';
import { PrepareGuard } from 'app/core/prepare.guard';
import { BreezeDxStoreService, CustomStore } from './breeze-dx-store.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { RequestInterceptorService } from './request-interceptor.service';
import { MessageService } from './message.service';
import { EntitiesService } from 'app/core/data/entities.service';
import { PartPurchaseRepository } from 'app/core/data/partPurchase.repository';
import { ReportService } from 'app/core/data/report.service';
import { ToastErrorHandler } from 'app/core/toast-error-handler.service';
import { PortalService } from 'app/core/data/portal.service';
import { UtilityService } from 'app/core/data/utility.service';
import { QuickbooksService } from 'app/core/data/quickbooks.service';
import { PendingChangesGuard, ComponentCanDeactivate } from './pending-changes.guard';
import { JwtInterceptor } from './jwt.interceptor';
import { ErrorInterceptor } from './error-interceptor';
import { OrderService } from './data/order.service';
import { InvoiceService } from './data/invoice-service';

export {
    AppInformationService as AppInformationService1,
    PrepareGuard,
    EntitiesService,
    PartPurchaseRepository,
    PendingChangesGuard,
    ComponentCanDeactivate,
    AuthGuard,
    AuthService,
    AppInformationService,
    SessionInformationService,
    GenesisUnitOfWork,
    BreezeDxStoreService,
    CustomStore,
    MessageService,
    ReportService,
    PortalService,
    UtilityService,
    QuickbooksService,
    OrderService,
    InvoiceService
};

export function appInitializer(authenticationService: AuthService) {
    return () =>
        new Promise((resolve: any) => {
            // attempt to refresh token on app start up to auto authenticate
            authenticationService.refreshToken().subscribe().add(resolve);
        });
}

@NgModule({ declarations: [], imports: [CommonModule], providers: [
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthService] },
        // { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ToastErrorHandler },
        AppInformationService,
        EntitiesService,
        PartPurchaseRepository,
        PrepareGuard,
        AuthGuard,
        AuthService,
        SessionInformationService,
        AppInformationService,
        GenesisUnitOfWork,
        EntityManagerProvider,
        BreezeDxStoreService,
        ReportService,
        PortalService,
        UtilityService,
        QuickbooksService,
        OrderService,
        InvoiceService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [AppInformationService, AuthService, SessionInformationService, AppInformationService, GenesisUnitOfWork, EntityManagerProvider, BreezeDxStoreService],
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
